module.exports = __webpack_public_path__ + "static/img/06.8f3b64f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/06.png
// module id = YXCc
// module chunks = 0